const googleId = process.env.VUE_APP_GOOGLE_TAG_ID;
const ga = document.createElement("script");

ga.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${googleId}`);
document.head.appendChild(ga);

window.dataLayer = window.dataLayer || [];

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

gtag("js", new Date());

function pageview(path) {
  gtag("config", googleId, {
    page_path: path,
  });
}

export default pageview;
